import { indexItems } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="w-full py-14 md:py-20 bg-background-50 scroll-mt-20">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-4xl font-heading text-foreground-900 mb-3">
              专题合集
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
              七大剧集品类，满足你的每一种追剧口味
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {indexItems.slice(0, 3).map((item) => (
              <div
                key={item.title}
                className="group relative bg-background-50 border border-background-200/70 rounded-lg p-5 md:p-6 hover:border-primary-300 transition-colors duration-200 cursor-pointer"
              >
                <div className="flex items-start justify-between mb-3">
                  <div className="w-10 h-10 rounded-md bg-primary-100 flex items-center justify-center text-primary-600 text-lg">
                    <i className={item.icon}></i>
                  </div>
                  <span className="text-xs px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 font-medium whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <h3 className="text-base md:text-lg font-heading text-foreground-900 mb-2">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                  {item.description}
                </p>
              </div>
            ))}

            <div className="sm:col-span-2 lg:col-span-1 grid grid-cols-2 sm:grid-cols-2 gap-4 md:gap-5">
              {indexItems.slice(3, 5).map((item) => (
                <div
                  key={item.title}
                  className="group bg-background-50 border border-background-200/70 rounded-lg p-4 md:p-5 hover:border-primary-300 transition-colors duration-200 cursor-pointer"
                >
                  <div className="w-8 h-8 rounded-md bg-primary-100 flex items-center justify-center text-primary-600 text-base mb-3">
                    <i className={item.icon}></i>
                  </div>
                  <h3 className="text-sm md:text-base font-heading text-foreground-900 mb-1.5">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                    {item.description}
                  </p>
                </div>
              ))}
              {indexItems.slice(5, 7).map((item) => (
                <div
                  key={item.title}
                  className="group bg-background-50 border border-background-200/70 rounded-lg p-4 md:p-5 hover:border-primary-300 transition-colors duration-200 cursor-pointer"
                >
                  <div className="w-8 h-8 rounded-md bg-primary-100 flex items-center justify-center text-primary-600 text-base mb-3">
                    <i className={item.icon}></i>
                  </div>
                  <h3 className="text-sm md:text-base font-heading text-foreground-900 mb-1.5">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                    {item.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}